import { TableContact } from "../../../general/src/TableContact";
import { Checkbox, CityState, DataSource, Layout, Panel, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSalesperson extends Layout {
    checkboxIsManager: Checkbox;
    citystateSalesperson: CityState;
    layoutTableContact: TableContact;
    panelGeneralCenter: Panel;
    panelGeneralLeft: Panel;
    panelGeneralRight: Panel;
    sourceContact: DataSource;
    sourceSalesperson: DataSource;
    tabGeneral: Tab;
    tabTab2: Tab;
    tabsetSalespserson: Tabset;
    textboxAddress: Textbox;
    textboxId: Textbox;
    textboxName: Textbox;
    textboxPercentage: Textbox;
    textboxSalesManagerId: Textbox;
    textboxUserId: Textbox;
}
